import * as React from "react";
import { Facebook, Twitter, Instagram, Linkedin, MapPin, Phone, Mail, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
const services = ["Residential Relocation", "Commercial Logistics", "White-Glove Packing", "Secure Storage Units", "Specialty Item Handling", "Corporate Moving"];
const serviceAreas = ["Moving Guides", "Packing Checklists", "Insurance Options", "Tracking Portal", "Customer Support", "FAQs"];
const socialLinks = [{
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}, {
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}];
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="265059" id="footer" className="bg-secondary text-secondary-foreground pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block w-fit">
              <WvcLogo className="h-8 w-auto text-primary [&_svg]:h-8 [&_svg]:w-auto [&_svg]:text-primary" />
            </Link>
            <p className="text-secondary-foreground/70 text-sm leading-relaxed max-w-xs font-default">
              Shift is a professional moving company dedicated to providing reliable, stress-free relocation services. We manage every detail with kinetic precision and care.
            </p>
            <div className="flex items-center gap-2 mt-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Button key={i} data-index={i} variant="ghost" size="icon" asChild className="text-secondary-foreground/70 hover:text-primary hover:bg-primary/10 rounded-md transition-all">
                    <Link to={social.href} aria-label={social.label}>
                      <Icon className="size-4" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold tracking-tight uppercase text-secondary-foreground">
              Our Services
            </h3>
            <ul className="flex flex-col gap-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="/GetQuotePage" className="text-secondary-foreground/70 hover:text-primary text-sm transition-colors inline-flex items-center gap-2 group font-default">
                    <ArrowRight className="size-3 opacity-0 -ml-5 transition-all group-hover:opacity-100 group-hover:ml-0 text-primary" />
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold tracking-tight uppercase text-secondary-foreground">
              Resources
            </h3>
            <ul className="flex flex-col gap-3">
              {serviceAreas.map((area, i) => <li key={i} data-index={i}>
                  <Link to="/ResourcesPage" className="text-secondary-foreground/70 hover:text-primary text-sm transition-colors inline-flex items-center gap-2 group font-default">
                    <ArrowRight className="size-3 opacity-0 -ml-5 transition-all group-hover:opacity-100 group-hover:ml-0 text-primary" />
                    {area}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold tracking-tight uppercase text-secondary-foreground">
              Contact Us
            </h3>
            <ul className="flex flex-col gap-4">
              <li>
                <Link to="#" className="flex items-start gap-3 text-secondary-foreground/70 hover:text-primary transition-colors group">
                  <MapPin className="size-5 shrink-0 mt-0.5 text-primary/50 group-hover:text-primary transition-colors" />
                  <span className="text-sm leading-tight font-default">
                    88 Logistics Way<br />
                    Metro City, MC 90210
                  </span>
                </Link>
              </li>
              <li>
                <Link to="#" className="flex items-center gap-3 text-secondary-foreground/70 hover:text-primary transition-colors group">
                  <Phone className="size-5 shrink-0 text-primary/50 group-hover:text-primary transition-colors" />
                  <span className="text-sm font-default">(800) SHIFT-NOW</span>
                </Link>
              </li>
              <li>
                <Link to="#" className="flex items-center gap-3 text-secondary-foreground/70 hover:text-primary transition-colors group">
                  <Mail className="size-5 shrink-0 text-primary/50 group-hover:text-primary transition-colors" />
                  <span className="text-sm font-default">hello@shiftmoves.com</span>
                </Link>
              </li>
            </ul>
            
          </div>

        </div>

        <Separator className="my-8 bg-secondary-foreground/10" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-secondary-foreground/50 font-default">
          <p>
            &copy; {currentYear} SHIFT Logistics. Engineered for movement.
          </p>
          <div className="flex items-center gap-4">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
            
          </div>
        </div>
      </div>
    </section>;
}